var map = {
	"./AppleMusic.svg": 491,
	"./CopyLinkIcon.svg": 86,
	"./CopyLinkIcon2.svg": 196,
	"./Instagram.svg": 492,
	"./SoundCloud.svg": 493,
	"./Spotify.svg": 494,
	"./Tidal.svg": 495,
	"./TikTok.svg": 496,
	"./Twitter.svg": 497,
	"./Venmo.svg": 498,
	"./YouTube.svg": 499,
	"./activity-icon.svg": 500,
	"./add.svg": 501,
	"./addActive.svg": 79,
	"./affiliations.svg": 502,
	"./affiliationsActive.svg": 503,
	"./attach.svg": 504,
	"./badge.svg": 505,
	"./badges.svg": 197,
	"./cancel-upload.svg": 198,
	"./cheveron-down.svg": 78,
	"./close-arrow-accent.svg": 199,
	"./close-icon.svg": 506,
	"./comments-icon.svg": 259,
	"./connect.svg": 116,
	"./copy.svg": 200,
	"./createFolder.svg": 507,
	"./cross-icon.svg": 47,
	"./cross.svg": 165,
	"./customization.svg": 508,
	"./customizationActive.svg": 509,
	"./data-icon.svg": 260,
	"./deletePermanently.svg": 510,
	"./delete_forever.svg": 511,
	"./down-arrow.svg": 166,
	"./down-icon.svg": 120,
	"./down.svg": 96,
	"./download-share.svg": 107,
	"./download-shared-files-logo.svg": 512,
	"./download-shared-files.svg": 513,
	"./download.svg": 514,
	"./downloaded-white.svg": 201,
	"./downloads.svg": 515,
	"./duplicate.svg": 516,
	"./edit.svg": 202,
	"./electricBolt.svg": 261,
	"./email.svg": 203,
	"./expire.svg": 517,
	"./facebook.svg": 204,
	"./favourite.svg": 67,
	"./files-icon.svg": 262,
	"./folder.svg": 129,
	"./folderActive.svg": 70,
	"./icon-arrow-right.svg": 97,
	"./icon-document.svg": 518,
	"./image-preview.svg": 124,
	"./info.svg": 263,
	"./info_white.svg": 519,
	"./instagram-orange.svg": 520,
	"./integrations.svg": 521,
	"./integrationsActive.svg": 522,
	"./link-icon.svg": 264,
	"./link-playlist.svg": 205,
	"./lock-icon.svg": 523,
	"./login-background.svg": 524,
	"./loop.svg": 206,
	"./messanger.svg": 525,
	"./mic-icon.svg": 526,
	"./move.svg": 527,
	"./orange-filled-star.svg": 167,
	"./pause-play-circle.svg": 168,
	"./pause.svg": 169,
	"./pauseActive.svg": 528,
	"./pausePublic.svg": 93,
	"./pdf.svg": 265,
	"./permanentDelete.svg": 529,
	"./play.svg": 207,
	"./playActive.svg": 530,
	"./playIcon.svg": 208,
	"./playPublic.svg": 125,
	"./playlist-add.svg": 531,
	"./playlist-icon-white.svg": 209,
	"./playlist-icon.svg": 210,
	"./playlist-play-circle.svg": 211,
	"./playlist-tile.svg": 170,
	"./profile-img-accent.svg": 118,
	"./profile-img.svg": 266,
	"./profile.svg": 532,
	"./profileActive.svg": 533,
	"./recording.svg": 212,
	"./reload.svg": 534,
	"./restart.svg": 258,
	"./restore.svg": 535,
	"./rin.svg": 536,
	"./rocket.svg": 537,
	"./session.svg": 213,
	"./sessionCredit.svg": 126,
	"./share.svg": 214,
	"./signup-icon.svg": 130,
	"./soundexchange-icon.svg": 538,
	"./star-icon-outline.svg": 539,
	"./star-icon.svg": 540,
	"./star.svg": 541,
	"./subscription-active.svg": 542,
	"./subscription.svg": 543,
	"./trash-white.svg": 122,
	"./trash.svg": 95,
	"./twitter-orange.svg": 544,
	"./twitter-share.svg": 215,
	"./up-arrow.svg": 171,
	"./up-icon.svg": 119,
	"./upload.svg": 216,
	"./white-outline-star.svg": 53,
	"./youtube-orange.svg": 545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;